var exports = {
  "aN": "RestrictionItem__fnAlY4",
  "EE": "RestrictionText__Q8qiiQ",
  "MJ": "FormControl__Ue45Wq",
};

module.exports = exports;
